import React, { useEffect, useState } from 'react'
import { FaFile, FaFileCsv, FaFileImage, FaFilePdf } from 'react-icons/fa';
import toast, { Toaster } from 'react-hot-toast';
import { EntriesPerPage, Search, TableFetch } from '../../components/TableOptions';
import XLoader from '../../components/XLoader';
import { MdOutlineErrorOutline } from 'react-icons/md';
import { Button } from 'react-bootstrap';
import ImageLightbox from '../../components/ImageLightbox';
import PdfViewer from '../../components/PdfViewer';
import { Link } from 'react-router-dom';
import { getallapplicant, reset } from '../../features/Applicant/applicantSlice';
import { useAppDispatch, useAppSelector } from '../../useStore';
import moment from 'moment';
import Pagination from '../../components/Pagination';
import FilterListIcon from "@mui/icons-material/FilterList";
import TopNavigation from '../../layouts/top-navigation/TopNavigation';
import BottomNavigation from '../../layouts/bottom-navigation/BottomNavigation';

const Report = () => {
	const dispatch = useAppDispatch();


	const {
		EvalvationisSuccess,
		UpdateScreeningStatusisSuccess,
		sendOfferisSuccess,
		applicationInterviewisSuccess,
		updateApplicationInterviewStatusisSuccess,
		sendEmailisSuccess,
		shareApplicationisSuccess,
		ScreeningisSuccess,
		applicationassignedisSuccess,
		scheduleApplicantisSuccess,
		updateInterviewStatusisSuccess,
		UpdateOfferisSuccess,
		data,
		isError,
		isLoading,
		message,
	} = useAppSelector((state: { applicant: any }) => state.applicant);

	useEffect(() => {
		if (
			EvalvationisSuccess ||
			UpdateScreeningStatusisSuccess ||
			sendOfferisSuccess ||
			applicationInterviewisSuccess ||
			updateApplicationInterviewStatusisSuccess ||
			sendEmailisSuccess ||
			shareApplicationisSuccess ||
			ScreeningisSuccess ||
			applicationassignedisSuccess ||
			scheduleApplicantisSuccess ||
			updateInterviewStatusisSuccess ||
			UpdateOfferisSuccess
		) {
			const input = { applicationStatus: "HIRED" };
			// @ts-ignore 
			dispatch(getallapplicant(input))

			setTimeout(() => {
				dispatch(reset());
			}, 2000);
		}
	}, [EvalvationisSuccess, UpdateScreeningStatusisSuccess, sendOfferisSuccess, applicationInterviewisSuccess, updateApplicationInterviewStatusisSuccess, sendEmailisSuccess, shareApplicationisSuccess, ScreeningisSuccess, applicationassignedisSuccess, scheduleApplicantisSuccess, updateInterviewStatusisSuccess, UpdateOfferisSuccess, dispatch]);

	const headerTitles =
		[
			"Applicant Name",
			"Job Profile",
			"View ID",
			"Applied on",
			"Status",
			"Email",
			"Phone Number",
			"Average Interview Score",
			"Work Experience",
			"Relevant Work Experience",
			"Location",
		]


	useEffect(() => {
		const input = { applicationStatus: "HIRED" };
		// @ts-ignore 
		dispatch(getallapplicant(input))

	}, [dispatch]);


	// useEffect(() => {
	// 	if (isError) {
	// 		swal({
	// 			title: "error",
	// 			text: message,
	// 			icon: "error"
	// 		})
	// 		dispatch(reset())
	// 	}
	// }, [dispatch, isError, message])

	useEffect(() => {
		if (isError) {
			toast.error(message);
		}
		dispatch(reset());
	}, [dispatch, isError, message]);

	const [datas, setDatas] = useState([]);
	const [searchItem, setSearchItem] = useState("");

	const [entriesperpage, setEntriesPerPage] = useState(() => {
		return "8";
	});

	const Offered = data?.data?.filter((obj: any) => {
		return obj?.applicationStatus === "HIRED"
	})
	const [show, setShow] = useState(false);
	const [isPDF, setIsPDF] = useState(false);
	const [selectedFile, setSelectedFile] = useState(null);
	const openModal = (fileUrl: any, fileType: string, file: React.SetStateAction<null>) => {
		setSelectedFile(file);
		setIsPDF(fileType === 'pdf');
		setShow(true);
	};


	const getFileIcon = (fileType: any) => {
		switch (fileType) {
			case 'pdf':
				return <FaFilePdf color={"red"} size={25} />;
			case 'csv':
				return <FaFileCsv size={25} color={"green"} />;
			case 'jpeg':
			case 'jpg':
			case 'png':
				return <FaFileImage size={25} color={"gray"} />;
			default:
				return <FaFile size={25} />;
		}
	};



	useEffect(() => {
		const result = Offered?.filter((item: any) =>
			item?.firstName?.toLowerCase()?.includes(searchItem) ||
			item?.middleName?.toLowerCase()?.includes(searchItem) ||
			item?.LastName?.toLowerCase()?.includes(searchItem)
		);
		setDatas(result);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [data, searchItem]);

	const [displayData, setDisplayData] = useState([]);




	return (
		<div id="screen-wrappers">
			<Toaster
				position="top-center"
				toastOptions={{
					duration: 5000,
					error: {
						duration: 20000,
					},
				}}
			/>
			<TopNavigation />
			<BottomNavigation />
			<div />
			<main>
				<div>
					<section className="md-ui component-data-table">
						<header className="main-table-header">
							<div className="main-table-search-container">
								<h1 className="table-header--title">Report</h1>
								<Search searchItem={searchItem} setSearchItem={setSearchItem} placeholder={"Report"} />
								<div>
									<EntriesPerPage
										data={datas}
										entriesperpage={entriesperpage}
										setEntriesPerPage={setEntriesPerPage}
									/>
								</div>
								<span className="table-header--icons">
									<FilterListIcon />
								</span>
							</div>
						</header>
						{isLoading && <XLoader isLoading={isLoading} />}
						<div className="main-table-wrapper">
							<table className="main-table-content">
								<thead className="data-table-header">
									<tr className="data-table-row">
										{headerTitles.map((title: any, i: any) => (
											<td
												className="table-datacell datatype-string headerTitles"
												key={i}
											>
												{title}
											</td>
										))}
									</tr>
								</thead>
								<tbody className="data-table-content">
									{isLoading ? (
										<TableFetch colSpan={12} />
									) : displayData?.length === 0 ||
										displayData?.length === undefined ? (
										<tr>
											<td className="table-msg" colSpan={12}>
												<MdOutlineErrorOutline size={75} />
												<p>No Record found!</p>
											</td>
										</tr>
									) : (
										displayData?.map((item: any, i: any) => (
											<tr className="data-table-row" key={i}>
												<td className="table-datacell datatype-numeric toggle">
													{item.firstName} {item.middleName} {item.LastName}
												</td>
												<td className="table-datacell datatype-string">
													<Link
														to={`/viewapplicants/${item?.id}`}
														className="applicant-btn"
													>
														<Button className="view-job-profile">View</Button>
													</Link>
												</td>

												<td className="table-datacell datatype-string">
													{item?.verificationID
														? (
															<span
																style={{ marginRight: '5px', cursor: 'pointer' }}
																onClick={() => {
																	const fileExtension = item?.verificationID.split('.').pop().toLowerCase();
																	openModal(item?.verificationID, fileExtension, item?.verification);
																}}>
																{getFileIcon(item.verificationID.split('.').pop().toLowerCase())}
															</span>
														)
														: 'No ID'
													}
												</td>
												<td className="table-datacell datatype-string">
													{moment(item?.createdAt).format("DD-MM-YYYY")}
												</td>
												<td className="table-datacell datatype-numeric">
													<Button className={"view-job-status"}>{"Offer Created"}</Button>
												</td>
												<td>{item.email}</td>
												<td className="table-datacell datatype-numeric">
													{!item.phoneNumber ? "n/a" : item?.phoneNumber}
												</td>
												<td className="table-datacell datatype-numeric">0</td>
												<td className="table-datacell datatype-string">
													{item.totalWorkExperience}
												</td>
												<td className="table-datacell datatype-string">
													{item.relevantWorkExperience}
												</td>
												<td className="table-datacell datatype-string">
													{!item?.location ? "n/a" : item?.location}
												</td>

											</tr>
										))
									)}
								</tbody>
							</table>
							{isPDF ? (
								<PdfViewer fileUrl={selectedFile} setShow={setShow} show={show} />
							) : (
								<ImageLightbox images={selectedFile} setShow={setShow} show={show} />
							)}
						</div>
						<div className="table-footer">


							<div>
								<Pagination
									setDisplayData={setDisplayData}
									data={datas}
									entriesperpage={entriesperpage}
									Total={"Offered"}
								/>
							</div>

						</div>
					</section>
				</div>
			</main>
		</div>
	)
}

export default Report
